import { gql } from '@apollo/client';
import { FRAGMENTS } from '../fragments';

const AssignOrder = gql`
  ${FRAGMENTS.ASSIGN_ORDER_ERROR}
  ${FRAGMENTS.ASSIGN_ORDER_DATA}
  mutation assignOrder($input: AssignOrderInput!) @api(name: live) {
    assignOrder(input: $input) {
        timestamp,
        ...AssignOrderError,
        ...AssignOrderData
    }
  }
`;

const UnAssignOrder = gql `
  mutation unAssignOrder($input: UnassignOrderInput!) @api(name: live) {
    unAssignOrder(input: $input) {
      result
    }
  }
`;

export const MUTATIONS = {
  ASSIGN_ORDER: AssignOrder,
  UNASSIGN_ORDER: UnAssignOrder
};
